/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  GuardrailMode,
  GuardrailMode$inboundSchema,
  GuardrailMode$outboundSchema,
} from "./guardrailmode.js";

export type TestGuardrailsResponse = {
  object: "guardrails_test_result";
  passed: boolean;
  triggeredGuardrail?: GuardrailMode | undefined;
  rejectionMessage?: string | undefined;
  userInput?: string | undefined;
  details?: { [k: string]: any } | undefined;
};

/** @internal */
export const TestGuardrailsResponse$inboundSchema: z.ZodType<
  TestGuardrailsResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("guardrails_test_result"),
  passed: z.boolean(),
  triggered_guardrail: GuardrailMode$inboundSchema.optional(),
  rejection_message: z.string().optional(),
  user_input: z.string().optional(),
  details: z.record(z.any()).optional(),
}).transform((v) => {
  return remap$(v, {
    "triggered_guardrail": "triggeredGuardrail",
    "rejection_message": "rejectionMessage",
    "user_input": "userInput",
  });
});
/** @internal */
export type TestGuardrailsResponse$Outbound = {
  object: "guardrails_test_result";
  passed: boolean;
  triggered_guardrail?: string | undefined;
  rejection_message?: string | undefined;
  user_input?: string | undefined;
  details?: { [k: string]: any } | undefined;
};

/** @internal */
export const TestGuardrailsResponse$outboundSchema: z.ZodType<
  TestGuardrailsResponse$Outbound,
  z.ZodTypeDef,
  TestGuardrailsResponse
> = z.object({
  object: z.literal("guardrails_test_result"),
  passed: z.boolean(),
  triggeredGuardrail: GuardrailMode$outboundSchema.optional(),
  rejectionMessage: z.string().optional(),
  userInput: z.string().optional(),
  details: z.record(z.any()).optional(),
}).transform((v) => {
  return remap$(v, {
    triggeredGuardrail: "triggered_guardrail",
    rejectionMessage: "rejection_message",
    userInput: "user_input",
  });
});

export function testGuardrailsResponseToJSON(
  testGuardrailsResponse: TestGuardrailsResponse,
): string {
  return JSON.stringify(
    TestGuardrailsResponse$outboundSchema.parse(testGuardrailsResponse),
  );
}
export function testGuardrailsResponseFromJSON(
  jsonString: string,
): SafeParseResult<TestGuardrailsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TestGuardrailsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TestGuardrailsResponse' from JSON`,
  );
}
